const data = {
    "icon-abacus": {
        "useStroke": false
    },
    "icon-account": {
        "useStroke": false
    },
    "icon-arrow_down": {
        "useStroke": false
    },
    "icon-arrow_repeat": {
        "primaryColor": "#FFF",
        "useStroke": false
    },
    "icon-arrow_up": {
        "useStroke": false
    },
    "icon-calendar": {
        "useStroke": false
    },
    "icon-camera": {
        "primaryColor": "#FFFFFF",
        "useStroke": false
    },
    "icon-chat": {
        "primaryColor": "#637D96",
        "useStroke": false
    },
    "icon-check": {
        "useStroke": false
    },
    "icon-chevron_down": {
        "primaryColor": "#99abbd",
        "useStroke": false
    },
    "icon-chevron_left": {
        "useStroke": false
    },
    "icon-chevron_right": {
        "useStroke": false
    },
    "icon-chevron_up": {
        "useStroke": false
    },
    "icon-clock": {
        "useStroke": false
    },
    "icon-close": {
        "useStroke": false
    },
    "icon-close2": {
        "useStroke": false
    },
    "icon-cog": {
        "primaryColor": "#262F3A",
        "useStroke": false
    },
    "icon-dot": {
        "primaryColor": "#262F3A",
        "useStroke": false
    },
    "icon-download": {
        "primaryColor": "#3799F0",
        "useStroke": false
    },
    "icon-edit": {
        "primaryColor": "#262F3A",
        "useStroke": true
    },
    "icon-ellipsis": {
        "primaryColor": "#262F3A",
        "useStroke": false
    },
    "icon-email-border-blue": {
        "primaryColor": "#3799F0",
        "useStroke": true
    },
    "icon-email": {
        "primaryColor": "#262F3A",
        "useStroke": false
    },
    "icon-envelope-alt": {
        "useStroke": false
    },
    "icon-error-lite": {
        "useStroke": false
    },
    "icon-error": {
        "primaryColor": "#262F3A",
        "useStroke": false
    },
    "icon-external_link": {
        "useStroke": false
    },
    "icon-flexible": {
        "useStroke": false
    },
    "icon-gift": {
        "useStroke": false
    },
    "icon-hide_password": {
        "primaryColor": "#99ABBD",
        "useStroke": true
    },
    "icon-info-lite": {
        "useStroke": false
    },
    "icon-info": {
        "primaryColor": "#99ABBD",
        "useStroke": false
    },
    "icon-information": {
        "useStroke": false
    },
    "icon-lock": {
        "primaryColor": "#637D96",
        "useStroke": false
    },
    "icon-medal": {
        "useStroke": false
    },
    "icon-notes": {
        "useStroke": false
    },
    "icon-notification-off": {
        "useStroke": false
    },
    "icon-notification-on": {
        "useStroke": false
    },
    "icon-phone-alt": {
        "useStroke": false
    },
    "icon-phone-border-blue": {
        "primaryColor": "#3799F0",
        "useStroke": true
    },
    "icon-phone": {
        "primaryColor": "#637D96",
        "useStroke": false
    },
    "icon-plus": {
        "useStroke": false
    },
    "icon-portfolio": {
        "useStroke": false
    },
    "icon-settings": {
        "useStroke": false
    },
    "icon-show_password": {
        "primaryColor": "#99ABBD",
        "useStroke": false
    },
    "icon-speedometer": {
        "useStroke": false
    },
    "icon-success-lite": {
        "useStroke": false
    },
    "icon-success": {
        "primaryColor": "#262F3A",
        "useStroke": true
    },
    "icon-target": {
        "useStroke": false
    },
    "icon-umbrella": {
        "useStroke": false
    },
    "icon-upload": {
        "primaryColor": "#FFFFFF",
        "useStroke": false
    },
    "icon-warning-lite": {
        "useStroke": false
    },
    "icon-warning": {
        "useStroke": false
    }
};
export default data;
//# sourceMappingURL=icons.js.map